import { Inject, Injectable, InjectionToken } from "@angular/core";
import { fromEvent, merge, Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";

export const MAX_IDLE_TIME_IN_SECONDS = new InjectionToken<number>(
  "Maximum idle time in seconds",
);

@Injectable({
  providedIn: "root",
})
export class IdleTimeService {
  private _maxIdleTimeExpired = new Subject<void>();

  get maxIdleTimeExpired() {
    return this._maxIdleTimeExpired.asObservable();
  }

  constructor(@Inject(MAX_IDLE_TIME_IN_SECONDS) maxIdleTimeInSeconds: number) {
    const idleTimeStarter = new Subject<void>();

    merge(
      idleTimeStarter,
      fromEvent(window, "click"),
      fromEvent(window, "keydown"),
      fromEvent(window, "wheel"),
      fromEvent(window, "mousedown"),
      fromEvent(window, "mouseup"),
      fromEvent(window, "touchstart"),
      fromEvent(window, "touchmove"),
    )
      .pipe(debounceTime(maxIdleTimeInSeconds * 1000))
      .subscribe(() => this._maxIdleTimeExpired.next());

    idleTimeStarter.next();
  }
}
